import { resolveInstitutionIcon } from '../lib/institutions';

interface Props {
  icon: string | null | undefined;
  institution?: string | null;
  name: string;
  color: string;
  size?: number;
}

/** Logo da instituição quando temos o SVG (por ícone ou por nome); senão inicial na cor. */
export function InstitutionLogo({ icon, institution, name, color, size = 36 }: Props) {
  const radius = Math.round(size * 0.3);
  const slug = resolveInstitutionIcon(icon, institution, name);
  if (slug) {
    return (
      <img
        src={`/institutions/${slug}.svg`}
        alt=""
        width={size}
        height={size}
        style={{ borderRadius: radius, width: size, height: size }}
        className="shrink-0 object-cover"
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className="inline-flex shrink-0 items-center justify-center font-bold text-white"
      style={{ width: size, height: size, borderRadius: radius, background: color, fontSize: size * 0.42 }}
    >
      {name.trim().charAt(0).toUpperCase()}
    </span>
  );
}
